import ajax from "../utils/request";

const jgDistrictConfigApi = {
  /********************************金刚区配置列表*********************************** */
  // 获取金刚区列表
  getJGConfigList(params) {
    return ajax({
      url: "/navigation/list",
      type: "get",
      params: params,
    });
  },
  addJGConfig(param) {
    return ajax({
      url: "/navigation/add",
      type: "post",
      params: param,
    });
  },
  editJGConfig(param) {
    return ajax({
      url: "/navigation/update",
      type: "post",
      params: param,
    });
  },
  removeJGConfig(param) {
    return ajax({
      url: "/navigation/del",
      type: "post",
      params: param,
    });
  },
};

export default jgDistrictConfigApi;
